import { useField } from 'informed';

import { SxProps, inputClasses } from '@mui/material';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import { formControlSx, inputLabelSx } from './FormControlStyled/FormControlStyled';
import { inputSx } from './TextField/TextField';

import { /*dayjs,*/ Dayjs } from 'dayjs';
/*import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);*/

interface Props {
  id?: string;
  name: string;
  label?: string;
  placeholder?: string;
  value?: string | number;
  type?: string;
  readOnly?: boolean;
  InputStyles?: SxProps;
  maxLength?: string;
  required?: boolean;
  autoComplete?: string;
  validate?: ((value: string) => string | void) | undefined;
  minDate?: undefined | Dayjs;
  maxDate?: undefined | Dayjs;
}

const DateField = ({
  id: propsId,
  label,
  name,
  // type: propsType,
  readOnly,
  required,
  validate,
  minDate,
  maxDate,
}: Props) => {
  // const type = propsType || 'date';

  const { fieldState, fieldApi, render, ref } = useField({
    name,
    required,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-expect-error
    validate,
  });

  // The field state ( contains value, error, dirty.. etc)
  const { value } = fieldState;

  // The field api ( allows you to control the field )
  const { setValue, setError } = fieldApi;

  const handleChange = (value) => {
    setValue(value);
  };

  const id = propsId || name;

  return render(
    <MuiDatePicker
      sx={{ ...formControlSx, border: '1px solid var(--E4E4E4)' }}
      minDate={minDate}
      maxDate={maxDate}
      onError={(newError) => newError && setError(newError)}
      slotProps={{
        textField: {
          variant: 'standard',
          InputLabelProps: {
            sx: inputLabelSx,
          },
          // props: {
          //   sx: {
          //     [`.${inputClasses.input}`]: {
          //       marginLeft: "10px",
          //       "&:before": { borderBottom: "none" },
          //       border: "1px solid red",
          //     },
          //   },
          // },
          InputProps: {
            sx: {
              ...(theme) => inputSx(theme),
              '&:before, &:after': { borderBottom: 'none' },
              [`.${inputClasses.input}`]: {
                margin: ' 0 0 1rem 1rem',
              },
            },
          },
          id,
          autoComplete: 'off',
          /*inputProps: {

                        }*/
        },
        /*inputAdornment: {
                      sx: {
                      }
                    },*/
        openPickerButton: {
          sx: {
            // background: 'red'
            color: 'var(--input-color)',
            mr: 0,
            mt: '-1.1rem',
          },
        },
        openPickerIcon: {
          sx: {
            width: '2.5rem',
            height: '2.5rem',
          },
        },
        desktopPaper: {
          sx: {
            background: 'var(--modal-bg-color)',
            color: 'var(--input-color) !important',

            ['span, div, button']: {
              color: 'var(--input-color) !important',

              ['&[disabled]']: {
                color: 'rgba(221, 221, 221, 0.60) !important',
              },
            },
          },
        },
        mobilePaper: {
          sx: {
            background: 'var(--modal-bg-color)',
            color: 'var(--input-color) !important',

            ['span, div, button']: {
              color: 'var(--input-color) !important',

              ['&[disabled]']: {
                color: 'rgba(221, 221, 221, 0.60) !important',
              },
            },
          },
        },
        /*layout: {
                        sx: {
                            color: 'var(--input-color)',
                        }
                    },
                    leftArrowIcon: {
                        sx: {
                            color: 'var(--input-color)',
                        }
                    },
                    rightArrowIcon: {
                        sx: {
                            color: 'var(--input-color)',
                        }
                    },
                    calendarHeader: {
                        sx: {
                            color: 'var(--input-color)',
                        }
                    },
                    desktopTransition: {
                        color: 'var(--input-color)',
                    }*/
      }}
      // PopperProps={{
      //     sx: {
      //         background: 'red'
      //     }
      // }}
      inputRef={ref}
      label={label || ''}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-expect-error
      required={required}
      value={value}
      // timezone="Europe/Warsaw"
      onChange={(value) => handleChange(value)}
      format="YYYY-MM-DD"
      {...{ readOnly }}
    />,
  );
};

export default DateField;
